import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import { fetchTypesService } from '../../../components/Support/services/masterData';

import { createInitialMasterState } from './helpers';
import { TypeObj } from './support.types';

export const fetchTypesAsyncThunk = createAsyncThunk(
  'supportTypes/fetchTypes',
  async (_, { rejectWithValue }) => {
    const { status, statusCode, data, message } = await fetchTypesService();
    if (!status || statusCode !== 200 || !data)
      return rejectWithValue(message ?? 'Internal Server Error');
    return data;
  }
);

export const typesSlice = createSlice({
  name: 'supportTypes',
  initialState: createInitialMasterState<TypeObj>(),
  reducers: {
    clearError: state => {
      state.error = null;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchTypesAsyncThunk.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        fetchTypesAsyncThunk.fulfilled,
        (state, action: PayloadAction<TypeObj[]>) => {
          state.loading = false;
          state.data = action.payload;
        }
      )
      .addCase(fetchTypesAsyncThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { clearError } = typesSlice.actions;
export default typesSlice.reducer;
